import {
  Avatar,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import CustomDataGrid from '../../../common/components/dataGrid/CustomDataGrid'
import { Add as AddIcon } from '@mui/icons-material'
import DashboardLayout from '../../../common/layouts/DashboardLayout'
import { styled } from '@mui/system'
import {
  setCompanyId,
  setFilteredRows,
  setIsOrderActivatedView,
  setResellersList,
} from '../../../store/slice/homeSlice'
import StatusChip from '../../../common/components/mui/Chips'
import FilterAltOutlined from '@mui/icons-material/FilterAltOutlined'
import { getAllResellers } from '../../../api/get/getApi'
import { useSearchParams } from 'react-router-dom'
import { ResellersColumn } from '../../../common/components/dataGrid/columns/HomeColumns'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {
  executeWithTryCatch,
  formatDate,
  isResponseSuccess,
  normalizeApiResponse,
} from '../../../helpers/HelperFunctions'
import { useHomeRedux } from '../Home'
import {
  COMPANY_STATUS,
  COMPANY_STATUS_OBJ,
  TOAST_MESSAGES,
} from '../../../helpers/Constants'
import { useToastContext } from '../../../App'
import { FlexBox } from '../../../common/styles/styled-components/StyledContainers'
import { motion } from 'framer-motion'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import ConfirmationModal from '../../../common/components/custom/modal/modal'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { AltigenLogoFlipLoader } from '../../../common/components/loaders/loader'
import { api_DeleteResellerComany } from '../../../api/WebPortalAPI'
import { setIsLoading } from '../../../store/slice/commonSlice'


const FlexContainer = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-evenly',
  alignItems: 'center',
})

const Reseller = (props) => {
  // hooks
  const { dispatch, state } = useHomeRedux()
  const { state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const [searchparams] = useSearchParams()
  const [anchorEl, setAnchorEl] = useState(null)
  const [menuItems, setMenuItems] = useState([])
  const [filters, setFilters] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [isOpenDeleteConfirmation, setOpenDeleteConfirmation] = useState(false)
  const open = Boolean(anchorEl)

  //lifeCycles
  useEffect(() => {
    fetchResellerList()
    state.searchValue?.reseller && getFilteredRows()
    const OrderActivated = localStorage.getItem('OrderActivated')
    if(OrderActivated === 'true')
      dispatch(setIsOrderActivatedView(true))
  }, [state.searchValue?.reseller])

  const fetchResellerList = async () => {
    const companyId = searchparams.get('company_id')
    const _location = location?.pathname
    // if (!state.resellersList && _location !== "/reseller") {
    //   await getResellersListApi(companyId);
    // }
    dispatch(setCompanyId(companyId))
  }

  const getResellersListApi = async (serviceProviderId) => {
    const response = await getAllResellers(serviceProviderId)
    dispatch(setResellersList(response.data.result))
  }

  //Render filter
  const renderFilter = (params) => {
    return (
      <>
        <FlexContainer>
          {params.colDef.headerName}
          <IconButton
            aria-label="filter list"
            size="small"
            onClick={(e) => handleClick(e, params.field)}
          >
            {state.columnFilters.status ? (
              <FilterAlt sx={{ color: 'white' }} />
            ) : (
              <FilterAltOutlined sx={{ color: 'white' }} />
            )}
          </IconButton>
          {open.status && (
            <StatusFilter
              open={open.status}
              handleClose={handleClose}
              handleClick={() => {}}
              anchorEl={anchorEl.status}
              items={state.menuItems}
            />
          )}
          {open.regDate && (
            <DateFilter
              open={open.regDate}
              handleClose={handleClose}
              handleClick={() => {}}
              anchorEl={anchorEl.regDate}
              items={state.menuItems}
            />
          )}
          {open.primaryContact && (
            <PrimaryContactFilter
              open={open.primaryContact}
              handleClose={handleClose}
              handleClick={() => {}}
              anchorEl={anchorEl.primaryContact}
              items={state.menuItems}
            />
          )}
        </FlexContainer>
      </>
    )
  }

  const AnchorLink = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
  }))

  const handleSignUpUrlOpen = (url) => {
    window.open(url, '_blank')
  }

  const handleCopy = async (url) => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-write',
      })

      if (
        permissionStatus.state === 'granted' ||
        permissionStatus.state === 'prompt'
      ) {
        await navigator.clipboard.writeText(url)
        toast.showToast('Text copied to clipboard successfully!')
      } else {
        toast.showToast('Clipboard write permission denied', 'error')
      }
    } catch (err) {
      toast.showToast('Failed to copy text: ', 'error')
    }
    navigator.clipboard.writeText(url)
  }

  const handleOpenDeleteConfirmation = (row) => {
    setOpenDeleteConfirmation(true)
    setSelectedRow(row)
  }

  const renderCompanyName = (row, value) => {
    return [COMPANY_STATUS.Active, COMPANY_STATUS.ApprovalPending].includes(
      row?.companyStatus
    ) ? (
      <FlexBox>
        <Typography variant="tablePrimary">
          <Link
            underline="none"
            color="primary"
            onClick={() => props?.onRowClick(row)}
          >
            {value}
          </Link>
          <Tooltip title="Copy Login Url">
            <IconButton onClick={() => handleCopy(row?.loginUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>

        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: row.customerCount == 0 && 1.3 }}>
          {commonState.isMaster && (
            <Tooltip
              title={
                row.customerCount > 0
                  ? "Can't delete reseller with customers"
                  : 'Delete Reseller'
              }
              placement="right"
            >
              <IconButton
                color={row.customerCount > 0 ? 'default' : 'error'}
                onClick={() =>
                  row.customerCount == 0 && handleOpenDeleteConfirmation(row)
                }
                sx={{ display: 'none' }}
                disableRipple={row.customerCount > 0}
              >
                <DeleteOutlineIcon
                  color={row.customerCount > 0 ? 'default' : 'error'}
                  sx={{ fontSize: 14 }}
                />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    ) : (
      <FlexBox>
        <Typography variant="tablePrimary">
          {value}&nbsp;
          <Tooltip title="Copy Signup Url">
            <IconButton onClick={() => handleCopy(row?.signupUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>
        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: row.customerCount == 0 && 1.3 }}>
          {commonState.isMaster && (
            <Tooltip
              title={
                row.customerCount > 0
                  ? "Can't delete reseller, Reseller has customer(s)"
                  : 'Delete Reseller'
              }
              placement="right"
            >
              <IconButton
                color={row.customerCount > 0 ? 'default' : 'error'}
                onClick={() =>
                  row.customerCount == 0 && handleOpenDeleteConfirmation(row)
                }
                sx={{ display: 'none' }}
                disableRipple={row.customerCount > 0}
              >
                <DeleteOutlineIcon
                  color={row.customerCount > 0 ? 'default' : 'error'}
                  sx={{ fontSize: 14 }}
                />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    )
  }

  //render company
  const renderCompany = (params) => {
    const { row, value } = params
    return (
      <FlexContainer sx={{ gap: '1rem' }}>
        <Avatar alt="logo" src={row?.logoUrl} sx={{ width: 24, height: 24 }} />
        {renderCompanyName(row, value)}
      </FlexContainer>
    )
  }

  //Render Company Status
  const renderCompanyStatus = (statusId) => {
    const status = Object.keys(COMPANY_STATUS).find(
      (key) => COMPANY_STATUS[key] === statusId
    )

    return (
      <StatusChip
        label={
          statusId === COMPANY_STATUS.ApprovalPending
            ? 'Approval Pending'
            : status
        }
        variant="outlined"
        color={COMPANY_STATUS_OBJ[statusId].color}
        isSharp
      />
    )
  }

  //Filter in dataGrid
  const getFilteredRows = () => {
    const searchValue = state.searchValue?.reseller?.toLowerCase()
    if (!searchValue) {
    dispatch(setFilteredRows(state.resellersList))
    return
  }
    // const regex = new RegExp(searchValue, 'i')
    const filteredRows = state.resellersList.filter(
      (row) =>
        row.name?.toLowerCase().includes(searchValue) ||
        row.primaryContactEmail?.toLowerCase().includes(searchValue) ||
        // regex.test(formatDate(new Date(row.createdDateTime)))
        formatDate(new Date(row.createdDateTime))
        ?.toLowerCase()
        .includes(searchValue)
    )
    dispatch(setFilteredRows(filteredRows))
  }

  //close
  const handleClose = () => {
    setAnchorEl(null)
  }

  //click
  const handleClick = (event, field) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    if (field == 'companyStatus') setMenuItems(COMPANY_STATUS_OBJ)
  }

  const handleDeleteReseller = async () => {
    setOpenDeleteConfirmation(false)
    dispatch(setIsLoading(true))
    // TODO : call delete reseller api
    executeWithTryCatch(async () => {
      const response = await api_DeleteResellerComany({
        companyId: selectedRow.id,
      })
      if (isResponseSuccess(response)) {
        const resellers = [...state.resellersList]
        const index = resellers.findIndex(
          (customer) => customer.id === selectedRow.id
        )
        if (index === -1) return
        resellers.splice(index, 1)
        dispatch(setIsLoading(false))
        setTimeout(() => dispatch(setResellersList(resellers)), 1000)
        toast.showToast(TOAST_MESSAGES.ResellerDeleted)
      }
    }, handleDeleteError)
  }

  const handleDeleteError = (error) => {
    dispatch(setIsLoading(false))
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
  }

  const resellerColumnProps = {
    renderFilter: renderFilter,
    renderCompany: renderCompany,
    renderCompanyStatus: renderCompanyStatus,
  }

  return (
      
    <Grid container>
      {commonState.isLoading && <AltigenLogoFlipLoader />}
      <DashboardLayout
        name="Reseller"
        buttonStartIcon={<AddIcon />}
        handleButtonClick={(e, name) => {
          props.handleShowCompany(e, name)
        }}
        children={
          <CustomDataGrid
            columns={ResellersColumn(resellerColumnProps)}
            data={state.resellersList || []}
            searchValue={state.searchValue?.reseller}
            filteredRows={state.filteredRows}
            noDataText="Reseller"
            loading={!state.resellersList}
            // onRowClick={({ row }) => [companyStatus.Active, companyStatus.Approval].includes(row?.companyStatus) && props?.handleClick(row)}
          />
        }
      />
      <ConfirmationModal
        isOpen={isOpenDeleteConfirmation}
        title="Delete Reseller"
        content={
          <span>
            Are you sure you want to delete <b>{selectedRow?.name}</b> ?
          </span>
        }
        btnOk="Delete Reseller"
        btnCancel="Cancel"
        handleClose={() => setOpenDeleteConfirmation(false)}
        handleConfirm={handleDeleteReseller}
        size="sm"
      />
    </Grid>
  )
}

export default Reseller
